import React from "react";
import royalty from "../images/royalty.gif"

export default function EmptyProducts() {
  return (
    <div
      style={{
        width: "80%", 
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height:'30vh',paddingTop:'5em'
      }}>
        <img src={royalty} style={{ width: "80%",}} alt="emptyproducts" />
      </div>
  );
}
